export default __webpack_public_path__ + "static/media/Gold.c51a9ef6.png";